import { GenNode } from '../../../../types/carbon/models/GenNode'
import { flattenTree } from '../../../../utils/tree'
import { normalizeTablePath } from '../../../../utils/multitables'

/** Every Table-node full path (`folderPath/filename`, extension-stripped) present in a TOC.
 * Used to check whether a configured table reference still resolves (#970 Part C) and to
 * back the wizard's Step-1 table picker validity checks. */
export function tocTablePaths(toc: GenNode[]): Set<string> {
  const paths = new Set<string>()
  for (const node of flattenTree(toc)) {
    if (node.type !== 'Table') continue
    const filename = node.value1 || ''
    const folderPath = node.value2 || ''
    const fullPath = folderPath ? `${folderPath}/${filename}` : filename
    if (fullPath) paths.add(normalizeTablePath(fullPath))
  }
  return paths
}

/** True if `fullPath` resolves to a Table node currently in the TOC. */
export function tocHasTablePath(toc: GenNode[], fullPath: string): boolean {
  return tocTablePaths(toc).has(normalizeTablePath(fullPath))
}
